/**
 * This file defines the AngularJS module 'app.resources' and its run block.
 * It also initializes various caches using CacheFactory for caching data.
 * @module app.resources
 */
(function () {
    'use strict';

    function sanitizeDynamicTrendParams(params) {
        var trendParams = angular.extend({}, params);

        // ComplexCategory is only supported at point/radius level for housing
        if (+trendParams.Level !== 0 || +trendParams.PropertyCategory !== 1)
            delete trendParams.ComplexCategory;

        // dynamictrend never accepts ParcelId; parcel level (7) is housing-only
        delete trendParams.ParcelId;
        if (+trendParams.Level === 7 && +trendParams.PropertyCategory !== 1)
            trendParams.Level = 3;

        switch (+trendParams.Level) {
            case 9:
                delete trendParams.CityId;
                delete trendParams.CountyId;
                delete trendParams.DistrictId;
                delete trendParams.BlockId;
                break;
            case 1:
                delete trendParams.CountyId;
                delete trendParams.DistrictId;
                delete trendParams.BlockId;
                break;
            case 2:
                delete trendParams.DistrictId;
                delete trendParams.BlockId;
                break;
            case 6:
                delete trendParams.BlockId;
                break;
        }

        return trendParams;
    }

    angular
        .module('app.resources', [])
        .run(['CacheFactory', function (CacheFactory) {
            var storageImpl = {
                getItem: function (key) { return localStorage.getItem(key); },
                setItem: function (key, value) {
                    try {
                        return localStorage.setItem(key, value);
                    } catch (err) {
                        const accessToken = localStorage.getItem('accessToken');
                        const accessTokenExpires = localStorage.getItem('accessTokenExpires');
                        const refreshToken = localStorage.getItem('refreshToken');
                        const refreshTokenExpires = localStorage.getItem('refreshTokenExpires');
                        localStorage.clear();
                        localStorage.setItem('accessToken', accessToken);
                        localStorage.setItem('accessTokenExpires', accessTokenExpires);
                        localStorage.setItem('refreshToken', refreshToken);
                        localStorage.setItem('refreshTokenExpires', refreshTokenExpires);
                        window.userStorage.sync();
                        return localStorage.setItem(key, value);
                    }
                },
                removeItem: function (key) { return localStorage.removeItem(key); },
            };
            if (!CacheFactory.get('Exchanges')) {
                CacheFactory('Exchanges', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000, storageImpl: storageImpl,
                    cacheFlushInterval: 24 * 60 * 60 * 1000
                });
            }
            if (!CacheFactory.get('ExchangesTrend')) {
                CacheFactory('ExchangesTrend', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 12 * 60 * 60 * 1000, storageImpl: storageImpl,
                    cacheFlushInterval: 12 * 60 * 60 * 1000
                });
            }
            if (!CacheFactory.get('Uavts')) {
                CacheFactory('Uavts', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Valuations')) {
                CacheFactory('Valuations', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsAdmin')) {
                CacheFactory('ValuationsAdmin', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsDetail')) {
                CacheFactory('ValuationsDetail', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsInside')) {
                CacheFactory('ValuationsInside', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsComparable')) {
                CacheFactory('ValuationsComparable', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsHistory')) {
                CacheFactory('ValuationsHistory', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Demographies')) {
                CacheFactory('Demographies', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Elections')) {
                CacheFactory('Elections', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Fellows')) {
                CacheFactory('Fellows', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Arabic')) {
                CacheFactory('Arabic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('OpportunitiesList')) {
                CacheFactory('OpportunitiesList', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Agents')) {
                CacheFactory('Agents', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('AgentsGet')) {
                CacheFactory('AgentsGet', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000,
                    storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('AgentsSearch')) {
                CacheFactory('AgentsSearch', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000,
                    cacheFlushInterval: 5 * 60 * 1000,
                    storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('AgentsSuggestion')) {
                CacheFactory('AgentsSuggestion', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000,
                    cacheFlushInterval: 5 * 60 * 1000,
                    storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('AgentsById')) {
                CacheFactory('AgentsById', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 30 * 60 * 1000,
                    cacheFlushInterval: 5 * 60 * 1000,
                    storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('OpportsById')) {
                CacheFactory('OpportsById', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 30 * 60 * 1000,
                    cacheFlushInterval: 5 * 60 * 1000,
                    storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Geos')) {
                CacheFactory('Geos', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Geos2')) {
                CacheFactory('Geos2', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Geos3')) {
                CacheFactory('Geos3', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('GeoNames')) {
                CacheFactory('GeoNames', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            // if (!CacheFactory.get('Geos4')) {
            //     CacheFactory('Geos4', {
            //         deleteOnExpire: 'aggressive',
            //         maxAge: 48 * 60 * 60 * 1000//, storageImpl: storageImpl
            //     });
            // }
            if (!CacheFactory.get('Indices')) {
                CacheFactory('Indices', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Ngbhrs')) {
                CacheFactory('Ngbhrs', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsThematic')) {
                CacheFactory('ValuationsThematic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('AgentsThematic')) {
                CacheFactory('AgentsThematic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('OpportunitiesThematic')) {
                CacheFactory('OpportunitiesThematic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ProjectsThematic')) {
                CacheFactory('ProjectsThematic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('MallsThematic')) {
                CacheFactory('MallsThematic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Pois')) {
                CacheFactory('Pois', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Trade')) {
                CacheFactory('Trade', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('TKGM')) {
                CacheFactory('TKGM', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Zoning')) {
                CacheFactory('Zoning', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Risks')) {
                CacheFactory('Risks', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Megas')) {
                CacheFactory('Megas', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Projects')) {
                CacheFactory('Projects', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ProjectsList')) {
                CacheFactory('ProjectsList', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ProjectsListById')) {
                CacheFactory('ProjectsListById', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 30 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Comparables')) {
                CacheFactory('Comparables', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 15 * 60 * 1000,
                    cacheFlushInterval: 15 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('TotalRooms')) {
                CacheFactory('TotalRooms', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 15 * 60 * 1000,
                    cacheFlushInterval: 15 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('RetailStreets')) {
                CacheFactory('RetailStreets', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 15 * 60 * 1000,
                    cacheFlushInterval: 15 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('RetailStreets3')) {
                CacheFactory('RetailStreets3', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 15 * 60 * 1000,
                    cacheFlushInterval: 15 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('RetailStreets4')) {
                CacheFactory('RetailStreets4', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 15 * 60 * 1000,
                    cacheFlushInterval: 15 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('RetailStreets5')) {
                CacheFactory('RetailStreets5', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 15 * 60 * 1000,
                    cacheFlushInterval: 15 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('StreetViews')) {
                CacheFactory('StreetViews', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Malls')) {
                CacheFactory('Malls', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('MallsGet')) {
                CacheFactory('MallsGet', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('MallsById')) {
                CacheFactory('MallsById', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 30 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('OpportunitiesGet')) {
                CacheFactory('OpportunitiesGet', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsAssets')) {
                CacheFactory('ValuationsAssets', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsSimple')) {
                CacheFactory('ValuationsSimple', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('AreaCache')) {
                CacheFactory('AreaCache', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('CommentCache')) {
                CacheFactory('CommentCache', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('RegionCheckCache')) {
                CacheFactory('RegionCheckCache', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('RoomTypes')) {
                CacheFactory('RoomTypes', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('InvestmentDetail')) {
                CacheFactory('InvestmentDetail', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Investment')) {
                CacheFactory('Investment', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('InvestmentTrend')) {
                CacheFactory('InvestmentTrend', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('InvestmentThematic')) {
                CacheFactory('InvestmentThematic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
        }])
        .factory('Exchange', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('Exchanges');
                var cache2 = CacheFactory.get('ExchangesTrend');
                return $resource(appSettingsSvc.NEWCACHE + '/currency/:dest', {}, {
                    currency: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            date: '@date'
                        },
                        isArray: false,

                    },
                    trend: {
                        cache: cache2,
                        method: 'GET',
                        params: {
                            dest: "trend",
                        },
                        isArray: true,
                    }
                });

            }
        ])
        .factory('area_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('AreaCache');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    getMetrics: {
                        method: 'GET',
                        params: { dest: "EndeksaValuationSummary", isValuationValueFilterActive: '@isValuationValueFilterActive' },
                        isArray: false,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });

            }
        ])
        .factory('nps_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache2 = CacheFactory.get('CommentCache');
                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: { root: "EndeksaComments", dest: "GetList" },
                        isArray: false,
                        cache: cache2,
                        ignoreLoadingBar: true
                    }
                });

            }
        ])
        .factory('report_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {

                return $resource(appSettingsSvc.REPORT + '/:dest/:endpoint', {}, {
                    raporDogrula: {
                        method: 'GET',
                        params: { dest: "RaporDogrula" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    tasinmazreport: {
                        method: 'GET',
                        params: { dest: "tasinmazreport", TasinmazId: '@TasinmazId' },
                        isArray: false,
                        cache: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    getReport: {
                        method: 'POST',
                        params: {
                            dest: "GenerateReport",
                            ProductId: "@ProductId",
                            TasinmazId: "@TasinmazId",
                            UserId: "@UserId",
                            Lang: "@Lang",
                            IsRent: "@IsRent"
                        },
                        isArray: false
                    },
                    getReportAdmin: {
                        method: 'POST',
                        params: {
                            dest: "GenerateReport",
                            endpoint: "AdminReport",
                            ProductId: "@ProductId",
                            TasinmazId: "@TasinmazId",
                            UserId: "@UserId",
                            Lang: "@Lang",
                            IsRent: "@IsRent"
                        },
                        isArray: false
                    },
                });

            }
        ])
        .factory('Uavt', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('Uavts');
                return $resource(appSettingsSvc.CACHE + '/:root', {}, {
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            root: "uavt",
                            id: '@id'
                        },
                        isArray: false,

                    }
                });

            }
        ])
        .factory('valuationGETAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('Valuations');
                var cache2 = CacheFactory.get('ValuationsDetail');
                var cache3 = CacheFactory.get('ValuationsInside');
                var cache4 = CacheFactory.get('ValuationsComparable');
                var cache5 = CacheFactory.get('ValuationsHistory');
                return $resource(appSettingsSvc.NONCACHE + '/:root/:dest', {}, {
                    list: {
                        method: 'GET',
                        params: {
                            root: "tasinmazliste",
                            UserId: "@UserId",
                            ActivePageNumber: "@ActivePageNumber",
                            ItemSize: "@ItemSize",
                            Sort: 2,
                            Search: "@Search",
                            OrderBy: 1,
                            DataLevel: "@DataLevel",
                            CityId: "@CityId",
                            CountyId: "@CountyId",
                            DistrictId: "@DistrictId",
                            QuarterId: "@QuarterId",
                            Radius: "@Radius",
                            Lat: "@Lat",
                            Long: "@Long"
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache
                    },
                    details: {
                        method: 'GET',
                        params: {
                            root: "tasinmaz",
                            propertyid: "@propertyid",
                            name: "@name"
                        },
                        isArray: false,
                        cache: cache2
                    },
                    changeName: {
                        method: 'POST',
                        params: {
                            root: "tasinmaz",
                            propertyid: "@propertyid",
                            name: "@name"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    getFiles: {
                        method: 'GET',
                        params: {
                            root: "tasinmaz",
                            dest: "filelist",
                            propertyid: "@propertyid"
                        },
                        isArray: true,
                        ignoreLoadingBar: true
                    },
                    getNote: {
                        method: 'GET',
                        params: {
                            root: "tasinmaz",
                            dest: "note",
                            propertyid: "@propertyid"
                        },
                        isArray: false,
                        cache: false
                    },
                    deleteNote: {
                        method: 'DELETE',
                        params: {
                            root: "tasinmaz",
                            dest: "note",
                            propertyid: "@propertyid"
                        },
                        isArray: false
                    },
                    updateState: {
                        method: 'POST',
                        params: {
                            root: "tasinmazupdatestate",
                            propertyid: "@propertyid",
                            value: "@value",
                            date: "@date",
                            status: "@status"
                        },
                        isArray: false
                    },
                    delete: {
                        method: 'DELETE',
                        params: {
                            root: "tasinmaz",
                            id: "@id"
                        },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        params: {
                            root: "valuation",
                            propertyid: "@propertyid"
                        },
                        isArray: true,
                        cache: cache3
                    },
                    getAutoValuationInfo: {
                        method: 'GET',
                        params: {
                            root: "valuation",
                            dest: "GetAutoValuationInfo",
                            propertyid: "@propertyid"
                        },
                        isArray: false,
                        cache: false
                    },
                    getQueue: {
                        method: 'GET',
                        params: {
                            root: "valuationqueue",
                            propertyid: "@propertyid"
                        },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    history: {
                        method: 'GET',
                        params: {
                            root: "valuation",
                            propertyid: "@propertyid",
                            history: "@history"
                        },
                        isArray: false,
                        cache: cache5,
                        ignoreLoadingBar: true
                    },
                    select: {
                        method: 'POST',
                        params: {
                            root: "selectvaluation",
                            valuationid: "@valuationid"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    comparables: {
                        method: 'GET',
                        params: {
                            root: "comparables",
                            valuationid: "@valuationid",
                            propertyid: "@propertyid",
                            propertycategory: "@propertycategory",
                            countryid: "@countryid"
                        },
                        isArray: false,
                        cache: cache4,
                        ignoreLoadingBar: true
                    },
                    valuationsById: {
                        method: 'POST',
                        params: {
                            root: "tasinmazliste",
                            dest: "GetByValuationIds"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    getNote: {
                        method: 'GET',
                        params: {
                            root: "tasinmaz",
                            dest: "note"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    recalculate: {
                        method: 'POST',
                        params: {
                            root: 'investment',
                            dest: 'RecalculateScore'
                        },
                        isArray: false,
                        cancellable: true
                    }
                });
            }
        ])
        .factory('investmentAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('Investment');
                var cache2 = CacheFactory.get('InvestmentTrend');
                return $resource(appSettingsSvc.CACHE + '/:root/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            root: "investment"
                        },
                        isArray: true,
                        cancellable: true,
                        cache: cache2,
                        transformResponse: function (response) {
                            let cipherText = JSON.parse(response);
                            return JSON.parse(window.encodeResponse(cipherText));
                        }
                    },
                    search: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            root: 'investment',
                            dest: 'search'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    }
                });
            }
        ])
        .factory('valuationGETADMINAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('ValuationsAdmin');
                return $resource(appSettingsSvc.NONCACHE + '/:root/:dest', {}, {
                    list: {
                        method: 'GET',
                        params: {
                            root: "Tasinmazliste",
                            dest: "GetTasinmazListe",
                            UserId: "@UserId",
                            ActivePageNumber: "@ActivePageNumber",
                            ItemSize: "@ItemSize",
                            Sort: 2,
                            Search: "@Search",
                            OrderBy: 1,
                            DataLevel: "@DataLevel",
                            CityId: "@CityId",
                            CountyId: "@CountyId",
                            DistrictId: "@DistrictId"
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache
                    }
                });
            }
        ])
        .factory('valuationPOSTAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.VALUATION + '/:root/:dest', {}, {
                    set: {
                        method: 'POST',
                        params: {
                            root: "valuation"
                        },
                        isArray: true,
                        ignoreLoadingBar: true
                    },
                    setQueue: {
                        method: 'POST',
                        params: {
                            root: "valuationqueue",
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    createAutoValuationInfo: {
                        method: 'POST',
                        params: {
                            root: "valuation",
                            dest: "CreateAutoValuationInfo"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    deleteAutoValuationInfo: {
                        method: 'DELETE',
                        params: {
                            root: "valuation",
                            dest: "DeleteAutoValuationInfo"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    addNote: {
                        method: 'POST',
                        params: {
                            root: "tasinmaz",
                            dest: "note"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    changeFiles: {
                        method: 'POST',
                        params: {
                            root: "tasinmaz",
                            dest: "filelist"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    changeNote: {
                        method: 'POST',
                        params: {
                            root: "tasinmaznote",
                            propertyid: "@propertyid",
                            note: "@note"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                });
            }
        ])
        .factory('demographyApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Demographies');
                var api = $resource(appSettingsSvc.CACHE + '/:root/:dest', {}, {
                    _get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            root: "demography",
                            dest: "Values"
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true,
                        skipAuthorization: true,
                        transformResponse: function (response) {
                            let cipherText = JSON.parse(response);
                            return JSON.parse(window.encodeResponse(cipherText));
                        }
                    }
                });

                return {
                    get: function (params) {
                        params = angular.extend(sanitizeDynamicTrendParams(params), { captchaTokenCustom: window.ecSec() });
                        return api._get(params);
                    }
                };
            }
        ])
        .factory('demographyApiNoCache', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                var api = $resource(appSettingsSvc.NONPROXIED + '/:root/:dest', {}, {
                    _get: {
                        method: 'GET',
                        params: {
                            root: "demography",
                            dest: "Values"
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true,
                        transformResponse: function (response) {
                            let cipherText = JSON.parse(response);
                            return JSON.parse(window.encodeResponse(cipherText));
                        }
                    }
                });

                return {
                    get: function (params) {
                        params = angular.extend(sanitizeDynamicTrendParams(params), { captchaTokenCustom: window.ecSec() });
                        return api._get(params);
                    }
                };
            }
        ])
        .factory('electionApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Elections');
                return $resource(appSettingsSvc.CACHE + '/:root', {}, {
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            root: "election"
                        },
                        isArray: true,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });

            }
        ])
        .factory('fellowApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Fellows');
                return $resource(appSettingsSvc.CACHE + '/:root', {}, {
                    get: {
                        method: 'GET',
                        cache: cache,
                        params: {
                            root: "fellowcountryman"
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });

            }
        ])
        .factory('arabicApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('Arabic');
                return $resource(appSettingsSvc.CACHE + '/:root', {}, {
                    get: {
                        method: 'GET',
                        cache: cache,
                        params: {
                            root: "arabiccomparables"
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });

            }
        ])
        .factory('opportunitiesApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var Cache = CacheFactory.get('OpportunitiesList');
                return $resource(appSettingsSvc.NONCACHE + '/portfoliosearch', {}, {
                    getAll: {
                        method: 'GET',
                        cache: Cache,
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: false
                    }
                });
            }
        ])
        .factory('agentApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var agentCache = CacheFactory.get('Agents');
                var agentCache2 = CacheFactory.get('AgentsGet');
                var agentCache3 = CacheFactory.get('AgentsSearch');
                var agentCache4 = CacheFactory.get('AgentsSuggestion');
                var cacheById = CacheFactory.get('AgentsById');
                return $resource(appSettingsSvc.CACHE + '/:root/:func', {}, {
                    list: {
                        method: 'GET',
                        cache: agentCache,
                        params: {
                            func: "GetAgentList",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    suggest: {
                        method: 'GET',
                        cache: agentCache4,
                        params: {
                            func: "SuggestedAgentListForValuation",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    get: {
                        method: 'GET',
                        cache: agentCache2,
                        params: {
                            func: "GetAgentDetail",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        // ignoreLoadingBar: true
                    },
                    agentListings: {
                        method: 'GET',
                        cache: false,
                        params: {
                            func: "GetComparablesForAgentDetail",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    search: {
                        method: 'GET',
                        cache: agentCache3,
                        params: {
                            func: "AgentSearch",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: false
                    },
                    userRegions: {
                        method: 'GET',
                        cache: false,
                        params: {
                            func: "OnlyRegions",
                            root: "RealtorRegions"
                        },
                        isArray: true,
                        responseType: "json",
                        cancellable: false
                    },
                    agentsById: {
                        method: 'POST',
                        cache: cacheById,
                        params: {
                            func: "GetAgentListByAgentIds",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: false
                    }
                });
            }
        ])
        .factory('agentApiNonCache', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var regionCache = CacheFactory.get('RegionCheckCache');
                return $resource(appSettingsSvc.NONCACHE + '/:root/:func', {}, {
                    listByAdmin: {
                        method: 'GET',
                        cache: false,
                        params: {
                            func: "GetAgentListByAdmin",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    agentsByIdAdmin: {
                        method: 'POST',
                        cache: false,
                        params: {
                            func: "GetAgentListByAgentIdsByAdmin",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: false
                    },
                    regionCheck: {
                        method: 'GET',
                        cache: regionCache,
                        params: {
                            func: "regioncheck",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: false,
                        ignoreLoadingBar: true
                    },
                    regionUpdate: {
                        method: 'GET',
                        params: {
                            func: "UpdateRegion",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: false,
                        ignoreLoadingBar: true
                    },
                });
            }
        ])
        .factory('agentApiCached', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var agentCache = CacheFactory.get('Agents');
                // var agentCache2 = CacheFactory.get('AgentsGet');
                // var agentCache3 = CacheFactory.get('AgentsSearch');
                return $resource(appSettingsSvc.CACHE + '/:root/:func', {}, {
                    list: {
                        method: 'GET',
                        cache: agentCache,
                        params: {
                            func: "GetAgentList",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: false
                    }
                });
            }
        ])
        .factory('quakeApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                // var agentCache = CacheFactory.get('Agents');
                // var agentCache3 = CacheFactory.get('AgentsSearch');
                return $resource(appSettingsSvc.NONCACHE + '/:root/:func', {}, {
                    list: {
                        method: 'GET',
                        cache: false,
                        params: {
                            root: "earthquake",
                            func: "gettweets"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    map: {
                        method: 'GET',
                        cache: false,
                        params: {
                            root: "earthquake",
                            func: "getearthquakes"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('geoApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var geoCache = CacheFactory.get('Geos');
                var geo2Cache = CacheFactory.get('Geos2');
                var geo3Cache = CacheFactory.get('Geos3');
                var geoNamesCache = CacheFactory.get('GeoNames');
                // var geo4Cache = CacheFactory.get('Geos4');
                return $resource(appSettingsSvc.CACHE + '/:root/:dest', {}, {
                    getRaw: {
                        cache: geoCache,
                        method: 'GET',
                        params: {
                            root: "geomap"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        skipAuthorization: true

                    },
                    getByIdRaw: {
                        cache: geo2Cache,
                        method: 'GET',
                        params: {
                            root: "geomap"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        skipAuthorization: true
                    },
                    get: {
                        cache: geoCache,
                        method: 'GET',
                        params: {
                            root: "geo",
                            dest: "map"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        skipAuthorization: true,
                        transformResponse: function (response) {
                            return JSON.parse(window.encodeResponse(response));
                        }
                    },
                    getById: {
                        cache: geo2Cache,
                        method: 'GET',
                        params: {
                            root: "geo",
                            dest: "map"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        skipAuthorization: true,
                        transformResponse: function (response) {
                            return JSON.parse(window.encodeResponse(response));
                        }

                    },
                    getListById: {
                        cache: geo3Cache,
                        method: 'GET',
                        params: {
                            root: "geolistbyid"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        skipAuthorization: true

                    },
                    getCountries: {
                        cache: false,
                        method: 'GET',
                        params: {
                            root: "geo",
                            dest: "allcountries"
                        },
                        isArray: true,
                        skipAuthorization: true
                    },
                    getNamesByCountryId: {
                        cache: geoNamesCache,
                        method: 'GET',
                        params: {
                            root: "geo",
                            dest: "GetGeoNamesByCountryId"
                        },
                        isArray: false,
                        skipAuthorization: true
                    }
                    // getByIds: {
                    //     cache: geo4Cache,
                    //     method: 'POST',
                    //     params: {
                    //         root: "getgeomapbyids"
                    //     },
                    //     isArray: false,
                    //     responseType: "json",
                    //     cancellable: true

                    // },
                });

            }
        ])
        /* .factory('customRegionApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:root', {}, {
                    set: {
                        method: 'POST',
                        params: {
                            root: "geocustomregion"
                        },
                        isArray: false,
                        responseType: "json",

                    },
                    get: {
                        method: 'GET',
                        params: {
                            root: "geocustomregion"
                        },
                        isArray: true,
                        cache: false

                    },
                    del: {
                        method: 'DELETE',
                        params: {
                            root: "geocustomregion"
                        },
                        isArray: false,
                        responseType: "json",

                    }
                });

            }
        ]) */

        // New Api for Dynamic Indices
        .factory('indicesAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var indicesCache = CacheFactory.get('Indices');
                var api = $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    _trendAnalysis: {
                        cache: indicesCache,
                        method: 'GET',
                        params: {
                            dest: "dynamictrend"
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        skipAuthorization: true,
                        isArray: false,
                        cancellable: true,
                        // ignoreLoadingBar: true
                    }
                });

                return {
                    trendAnalysis: function (params) {
                        params = angular.extend(sanitizeDynamicTrendParams(params), { captchaTokenCustom: window.ecSec() });
                        return api._trendAnalysis(params);
                    }
                };
            }
        ])
        .factory('indicesAPINoCache', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                var api = $resource(appSettingsSvc.NONPROXIED + '/:dest', {}, {
                    _trendAnalysis: {
                        method: 'GET',
                        params: {
                            dest: "dynamictrend"
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        // ignoreLoadingBar: true
                    }
                });

                return {
                    trendAnalysis: function (params) {
                        params = angular.extend(sanitizeDynamicTrendParams(params), { captchaTokenCustom: window.ecSec() });
                        return api._trendAnalysis(params);
                    }
                };
            }
        ])
        .factory('landAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            dest: "landvaluation"
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: false
                    }
                });
            }
        ])

        // New Api for Report
        .factory('rpaApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    GenerateRpa: {
                        method: 'POST',
                        params: {
                            dest: "GenerateRpa"
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    }
                });
            }
        ])

        // .factory('retailApi', [
        //     '$resource', 'appSettingsSvc',
        //     function ($resource, appSettingsSvc) {
        //         return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
        //             types: {
        //                 method: 'GET',
        //                 params: {
        //                     dest: "RegionalAnalysisCompanyType"
        //                 },
        //                 headers: {
        //                     'Content-Type': 'application/json'
        //                 },
        //                 isArray: true,
        //                 cancellable: true
        //             },
        //             get: {
        //                 method: 'POST',
        //                 params: {
        //                     dest: "RegionalAnalysisCompany"
        //                 },
        //                 headers: {
        //                     'Content-Type': 'application/json'
        //                 },
        //                 isArray: true,
        //                 cancellable: true
        //             }
        //         });
        //     }
        // ])

        // Neighbourhoods API
        .factory('neighbourAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Ngbhrs');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            dest: 'neighborhoods'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true

                    }
                });
            }
        ])
        // Lead API
        .factory('leadAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    set: {
                        method: 'POST',
                        params: {
                            dest: 'leadform'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,

                    }
                });
            }
        ])
        // Lead API
        .factory('pollAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'survey'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,

                    },
                    district: {
                        method: 'GET',
                        params: {
                            dest: 'survey'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,

                    },
                    post: {
                        method: 'POST',
                        params: {
                            dest: 'survey'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,

                    }
                });
            }
        ])
        .factory('alertAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest/:dest2', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'alert'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: false
                    },
                    history: {
                        method: 'GET',
                        params: {
                            dest: 'alertcomparablehistory'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: true

                    },
                    set: {
                        method: 'POST',
                        params: {
                            dest: 'alert',
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,

                    },
                    reactivate: {
                        method: 'POST',
                        params: {
                            dest: 'alert',
                            Id: '@Id'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,

                    },
                    delete: {
                        method: 'DELETE',
                        params: {
                            dest: 'alert'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,

                    },
                    filter: {
                        method: 'GET',
                        params: {
                            dest: 'alertfilter',
                            dest2: 'getalertmatches'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: false
                    },
                    list: {
                        method: 'GET',
                        params: {
                            dest: 'alertlist'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        cache: false,
                        ignoreLoadingBar: false
                    }
                });
            }
        ])
        .factory('thematicAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('ValuationsThematic');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'tasinmazthematicmap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('thematicAgentsAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('AgentsThematic');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'RealtorRegionsThematicMap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('thematicQuakesAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                // var cache = CacheFactory.get('AgentsThematic');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'EarthquakeThematicMap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: false,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('thematicOpportunitiesAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('OpportunitiesThematic');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'PortfolioThematicMap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('thematicProjectsAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('ProjectsThematic');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'HousingProjectThematicMap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('thematicLocationsAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'excelthematicmap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('thematicMallsAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('MallsThematic');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'shoppingcenterthematicmap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('poiOptions', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:root', {}, {
                    post: {
                        method: 'POST',
                        params: {
                            root: "userpoioptions"
                        },
                        isArray: false,

                    },
                    get: {
                        method: 'GET',
                        params: {
                            root: "userpoioptions"
                        },
                        isArray: true,
                        ignoreLoadingBar: true

                    }
                });

            }
        ])
        .factory('thematicInvestmentAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('InvestmentThematic');
                return $resource(appSettingsSvc.CACHE + '/:dest/:dest2', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'Investment',
                            dest2: 'Thematic'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('poiAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Pois');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    catalog: {
                        method: 'GET',
                        params: {
                            dest: 'poi'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('poiAPICache', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            dest: 'poi'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('placesAPINew', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'places'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: false
                    }
                });
            }
        ])
        .factory('wktAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    set: {
                        method: 'POST',
                        params: {
                            dest: 'wkt'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'wkt'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    }
                });
            }
        ])
        .factory('layerApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'layeranalysis'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    }
                });
            }
        ])
        .factory('tradeApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Trade');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'TradePotentialIndex'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: cache
                    }
                });
            }
        ])
        .factory('tkgmApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('TKGM');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'salesdata'
                        },
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('urlSearchApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ])
        .factory('salesApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'SalesLayer'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,

                    }
                });
            }
        ])
        .factory('excelApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    updateRow: {
                        method: 'POST',
                        params: {
                            dest: 'excel'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true
                    },
                    get: {
                        method: 'POST',
                        params: {
                            dest: 'excelsearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    addRow: {
                        method: 'GET',
                        params: {
                            dest: 'excel'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true
                    },
                    delRow: {
                        method: 'DELETE',
                        params: {
                            dest: 'excel'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    getSales: {
                        method: 'GET',
                        params: {
                            dest: 'excelsales'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    delSales: {
                        method: 'DELETE',
                        params: {
                            dest: 'excelsales'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    postSales: {
                        method: 'POST',
                        params: {
                            dest: 'excelsales'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    salesPivot: {
                        method: 'GET',
                        params: {
                            dest: 'excelsalespivot'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true
                    }
                });
            }
        ])
        .factory('commonFeatures', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'commonfeatures'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ])
        .factory('zoningApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Zoning');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            dest: 'imar'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: true,
                        skipAuthorization: true
                    }
                });
            }
        ])
        .factory('riskApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Risks');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            dest: 'risk'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: true,
                        skipAuthorization: true
                    }
                });
            }
        ])
        // .factory('megaProjectApi', [
        //     '$resource', 'appSettingsSvc', 'CacheFactory',
        //     function ($resource, appSettingsSvc, CacheFactory) {

        //         var cache = CacheFactory.get('Megas');
        //         return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
        //             get: {
        //                 cache: cache,
        //                 method: 'GET',
        //                 params: {
        //                     dest: 'megaprojects'
        //                 },
        //                 headers: {
        //                     'Content-Type': 'application/json'
        //                 },
        //                 isArray: false,
        //                 cancellable: true
        //             }
        //         });
        //     }
        // ])
        .factory('demographySearchApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            dest: 'demographysearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        skipAuthorization: true,
                        isArray: false
                    }
                });
            }
        ])
        .factory('ownerRentedApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'OwnerRented'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('purchasingPowerApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'purchasingpower'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('findRegionApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    catalog: {
                        method: 'GET',
                        params: {
                            dest: 'searchsimilardistricts'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true
                    },
                    search: {
                        method: 'POST',
                        params: {
                            dest: 'searchsimilardistricts'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    group: {
                        method: 'POST',
                        params: {
                            dest: 'searchdistrictsbygroup'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    }
                });
            }
        ])
        .factory('reportStatusApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:root/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            root: 'reportrequests'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        ignoreLoadingBar: true
                    },
                    url: {
                        method: 'GET',
                        params: {
                            root: 'reportrequests',
                            dest: '@dest'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ])
        .factory('regionReportApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.REPORT + '/:dest/:endpoint', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            dest: 'regionreport'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                    },
                    del: {
                        method: 'DELETE',
                        params: {
                            dest: 'regionreport'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                });
            }
        ])
        .factory('legalApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            dest: 'legalquery'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                    }
                });
            }
        ])
        .factory('revenueApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            dest: 'dynamicmodel'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                    }
                });
            }
        ])
        .factory('projectsApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Projects');
                var cacheList = CacheFactory.get('ProjectsList');
                var cacheById = CacheFactory.get('ProjectsListById');
                return $resource(appSettingsSvc.NONCACHE + '/:root/:dest', {}, {
                    list: {
                        cache: cacheList,
                        method: 'GET',
                        params: {
                            root: 'housingprojects'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            root: 'housingprojects'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    },
                    projectsById: {
                        cache: cacheById,
                        method: 'POST',
                        params: {
                            root: 'housingprojects',
                            dest: 'GetByHousingProjectIds'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    }
                });
            }
        ])
        .factory('comparablesApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Comparables');
                var cache2 = CacheFactory.get('TotalRooms');
                return $resource(appSettingsSvc.NONCACHE + '/:dest/:dest2', {}, {
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    },
                    getByRef: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            dest: 'comparablesearchByRef'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    },
                    detail: {
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch',
                            dest2: 'searchdetail'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    },
                    getRooms: {
                        cache: cache2,
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch',
                            dest2: 'GetCommonRoomTypes'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('comparablesApiCached', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('RoomTypes');
                return $resource(appSettingsSvc.NONCACHE + '/:dest/:dest2', {}, {
                    getRooms: {
                        cache: cache2,
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch',
                            dest2: 'GetCommonRoomTypes'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                });
            }
        ])
        .factory('comparablesApiCached', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('InvestmentDetail');
                return $resource(appSettingsSvc.CACHE + '/:dest/:dest2', {}, {
                    detail: {
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch',
                            dest2: 'searchdetail'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache
                    },
                });
            }
        ])
        .factory('retailStreetsApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('RetailStreets');
                var cache3 = CacheFactory.get('RetailStreets3');
                var cache4 = CacheFactory.get('RetailStreets4');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        cache: cache,
                        method: 'POST',
                        params: {
                            dest: 'retailstreets'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    search: {
                        cache: cache3,
                        method: 'POST',
                        params: {
                            dest: 'retailstreetsearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    poi_match: {
                        cache: cache4,
                        method: 'POST',
                        params: {
                            dest: 'streetpoimatch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    }
                });
            }
        ])
        .factory('retailStreetsApiNonCache', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache5 = CacheFactory.get('RetailStreets5');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    buffer: {
                        cache: cache5,
                        method: 'POST',
                        params: {
                            dest: 'retailstreetbuffer'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('isochroneAPI', [
            '$resource',
            function ($resource) {
                return $resource('https://api.mapbox.com/isochrone/v1/mapbox/:type/:lng,:lat?contours_minutes=:minutes&contours_colors=:colors&polygons=true&access_token=pk.eyJ1IjoiZW5kZWtzYSIsImEiOiJja21kdWZvcjMxdXk2MnBwaGVneHJjeXB3In0.jsYPQYIVhGIYF4AXFS5O7A', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            type: '@type',
                            lat: '@lat',
                            lng: '@lng',
                            minutes: '@minutes',
                            colors: '@colors'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])

        // .factory('geocodeAPI', [
        //     '$resource',
        //     function ($resource) {
        //         return $resource('https://api.tomtom.com/search/2/geocode/:search.json?countrySet=TR&key=xHAk40RiUkJsPXwXbk95NT7IvYZlWVr0', {}, {
        //             get: {
        //                 method: 'GET',
        //                 params: {
        //                     search: '@search'
        //                 },
        //                 headers: {
        //                     'Content-Type': 'application/json'
        //                 },
        //                 isArray: false
        //             }
        //         });
        //     }
        // ])
        // .factory('reverseGeocodeAPI', [
        //     '$resource',
        //     function ($resource) {
        //         return $resource('https://api.tomtom.com/search/2/reverseGeocode/:lat,:lng.json?key=xHAk40RiUkJsPXwXbk95NT7IvYZlWVr0', {}, {
        //             get: {
        //                 method: 'GET',
        //                 params: {
        //                     lat: '@lat',
        //                     lng: '@lng'
        //                 },
        //                 headers: {
        //                     'Content-Type': 'application/json'
        //                 },
        //                 isArray: false
        //             }
        //         });
        //     }
        // ])
        .factory('streetViewAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('StreetViews');
                return $resource(appSettingsSvc.CACHE + '/streetview', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            lat: '@lat',
                            lon: '@lon',
                            size: '@size',
                            propertyid: '@propertyid'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('shareAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:end', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            end: 'ContactsShared'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false
                    },
                    view: {
                        method: 'POST',
                        params: {
                            end: 'ContactsSharedViewCount'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    }
                });
            }
        ])
        .factory('updateThemeAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(
                    appSettingsSvc.NONCACHE + '/updatetheme/:theme', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            theme: '@theme'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    }
                }
                );
            }
        ]).factory('mallsAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Malls');
                var cache2 = CacheFactory.get('MallsGet');
                var cacheById = CacheFactory.get('MallsById');
                return $resource(
                    appSettingsSvc.NONCACHE + '/:operation/:dest', {}, {
                    storeCategories: {
                        method: 'GET',
                        params: {
                            operation: 'StoreCategories'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    stores: {
                        method: 'GET',
                        params: {
                            operation: 'StoreSearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    atms: {
                        method: 'GET',
                        params: {
                            operation: 'ATMSearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    list: {
                        method: 'GET',
                        params: {
                            operation: 'ShoppingCenters'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: false
                    },
                    get: {
                        method: 'GET',
                        params: {
                            operation: 'ShoppingCenters'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache2,
                        ignoreLoadingBar: false
                    },
                    search: {
                        method: 'GET',
                        params: {
                            operation: 'ShoppingCenterSearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    mallsById: {
                        method: 'POST',
                        params: {
                            operation: 'ShoppingCenters',
                            dest: 'GetByShoppingCenterIds'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: false,
                        cache: cacheById
                    }
                }
                );
            }
        ]).factory('opportListURLAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest?ListingURL=:urlData', {}, {
                    urlListGet: {
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch',
                            urlData: '@urlData'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    }
                });
            }
        ]).factory('opportListAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                // appSettingsSvc.NONCACHE
                var cache = CacheFactory.get('OpportsById');
                return $resource(appSettingsSvc.NONCACHE + '/:operation/:dest', {}, {
                    residentialAdd: {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        params: {
                            operation: 'portfoliohouse'
                        },
                        isArray: false
                    },
                    landAdd: {
                        method: 'POST',
                        headers: { 'Content-type': 'application/json' },
                        params: {
                            operation: 'portfolioland'
                        },
                        isArray: false
                    },
                    commercialAdd: {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        params: {
                            operation: 'portfoliocommercial'
                        },
                        isArray: false
                    },
                    opportDelete: {
                        method: 'DELETE',
                        params: { operation: "portfolio", portfolioId: '@portfolioId' },
                    },
                    opportUpdate: {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        params: {
                            operation: 'portfolio'
                        },
                        isArray: false
                    },
                    opportsById: {
                        cache: cache,
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        params: {
                            operation: 'opportunity',
                            dest: 'GetByOpportunityIds'
                        },
                        isArray: false
                    },
                });
            }
        ]).factory('opportunitiesGetApi', ['$resource', 'appSettingsSvc', 'CacheFactory', function ($resource, appSettingsSvc, CacheFactory) {

            var cache = CacheFactory.get('OpportunitiesGet');

            // appSettingsSvc.NONCACHE
            return $resource(appSettingsSvc.NONCACHE + '/:operation/:dest', {}, {
                // getByIdIp: {
                //     method: 'GET',
                //     headers: { 'Content-Type': 'application/json', ClientIp: ip },
                //     params: {
                //         operation: 'portfolio',
                //         portfolioId: '@portfolioId',
                //     },
                //     cache: cache2
                // },
                getById: {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    params: {
                        operation: 'portfolio',
                        portfolioId: '@portfolioId'
                    },
                    cache: cache
                },
                getOwnById: {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    params: {
                        operation: 'portfolio',
                        dest: 'GetWithDetail',
                        portfolioId: '@portfolioId'
                    },
                    cache: false
                }
            });
        }]).factory('assetsApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                // appSettingsSvc.NONCACHE

                var cache = CacheFactory.get('ValuationsAssets');
                return $resource(appSettingsSvc.CACHE + '/assetmanagement', {}, {
                    get: {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        cache: cache
                    }
                });
            }
        ]).factory('opportPropertyId', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:operation?Propertyid=:Propertyid&Language=:Language', {}, {
                    propertyById: {
                        method: 'GET',
                        params: {
                            operation: 'portfolio',
                            Propertyid: '@PropertyId',
                            Language: '@Language'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ]).factory('s3Files', ['$resource', 'appSettingsSvc', function ($resource, appSettingsSvc) {
            return {
                uploadImg: function () {
                    return $resource(appSettingsSvc.NONCACHE + '/:operation', {}, {
                        query: {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            params: {
                                operation: 'imageupload',
                                FileName: '@fileName',
                                Path: '@stringPath',
                                ImageBase64: '@imageBase64'
                            },
                            isArray: false
                        },
                        queryFile: {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            params: {
                                operation: 'fileupload',
                                FileName: '@fileName',
                                Path: '@stringPath',
                                ImageBase64: '@imageBase64'
                            },
                            isArray: false
                        },
                        delete: {
                            method: 'DELETE',
                            headers: { 'Content-Type': 'application/json' },
                            params: {
                                operation: 'imageupload',
                                url: '@url'
                            },
                            isArray: false
                        }
                    });
                }
            };
        }]).factory('valuationData', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('ValuationsSimple');
                return $resource(appSettingsSvc.NONCACHE + '/:operation?propertyid=:propertyid', {}, {
                    getValuationByPropertyId: {
                        method: 'GET',
                        params: {
                            operation: 'tasinmazsimple',
                            propertyid: '@propertyid'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ]).factory('addressValidatorAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/AddressValidator', {}, {
                    post: {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ]).factory('complexAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/complexsearchpoint', {}, {
                    get: {
                        cache: true,
                        method: 'GET',
                        isArray: false,
                    }
                });

            }
        ]).factory('addressAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/AdresSorgu/:dest', {}, {
                    getCities: {
                        cache: false,
                        method: 'GET',
                        isArray: true,
                        params: { dest: 'GetCities' }
                    },
                    getCounties: {
                        cache: false,
                        method: 'GET',
                        isArray: true,
                        params: { dest: 'GetCountiesByCityId' }
                    },
                    getDistricts: {
                        cache: false,
                        method: 'GET',
                        isArray: true,
                        params: { dest: 'GetDistrictsByCountyId' }
                    },
                    getStreets: {
                        cache: false,
                        method: 'GET',
                        isArray: true,
                        params: { dest: 'GetStreetsByDistrictId' }
                    },
                    getBuildings: {
                        cache: false,
                        method: 'GET',
                        isArray: true,
                        params: { dest: 'GetBuildingsByStreetId' }
                    }
                });

            }
        ]).factory('priceAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/RegionalPrice/:dest', {}, {
                    getRegionalPriceRatio: {
                        cache: false,
                        method: 'GET',
                        isArray: false,
                        params: { dest: 'GetRegionalPrice' }
                    },
                    getRegionalPrice: {
                        cache: false,
                        method: 'GET',
                        isArray: false,
                        params: { dest: 'GetRegionalPricebyCoefficients' }
                    },
                });

            }
        ]);
})();
